module.exports = __webpack_public_path__ + "static/picture-tnt-abec4e47e32f254682d25d2d2f714bdc.jpg";